import { sendMetric, getWhatId, checkReachGoalReady } from "@utils";
import { inject, observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
const { VITE_WHAT_ID } = import.meta.env;

import "./style.scss";

const Default = inject("mainStore")(
    observer(({ mainStore, isVisible }) => {
        const userLocation = mainStore.getMainStore("userLocation");
        const isStart = mainStore.getMainStore("isStart");
        const wdCd = mainStore.getMainStore("codeTypeMetrika");
        const abTestMetika = mainStore.getMainStore("abTestMetika");
        const wdm = mainStore.getMainStore("codeWdm");
        const wd_mc = mainStore.getMainStore("codeWdMc");
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const [isOpen, setIsOpen] = useState(true);
        const openScrollPositionRef = useRef(0);

        if (userLocation?._gtip?.success !== false) return;
        const ref = useRef(null);

        useEffect(() => {
            if (isOpen && !isStart) {
                sendMetric(`show_vpn_popup`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: null,
                    params3: null,
                    params4: null,
                    params6: null,
                    params7: wdCd ? wdCd : null,
                    params8: `${what_id}`,
                });

                checkReachGoalReady()
                    .then(() => {
                        // window.risMetrika.reachgoal_ch({
                        //     event: "show_vpn_popup",
                        //     siteId: what_id,
                        //     session_uuid: localStorage.getItem("_r_p_s"),
                        //     widget_code: wdCd ? wdCd : "",
                        // });
                    })
                    .catch((error) => {
                        console.error("Не удалось загрузить reachgoal_ch:", error);
                    });
            }
        }, [isOpen, isStart]);

        useEffect(() => {
            if (isVisible) {
                setIsOpen(false);
            }
        }, [isVisible]);

        useEffect(() => {
            const getFourOffersScrollSize = () => {
                const firstOffer = document.querySelector(".list-item, .list-item__accordion");

                if (!firstOffer) {
                    return;
                }

                const style = window.getComputedStyle(firstOffer);
                const marginBottom = parseFloat(style.marginBottom) || 0;

                return firstOffer.offsetHeight * 4 + marginBottom * 4;
            };

            const offersScroll = getFourOffersScrollSize();

            const handleScroll = () => {
                if (!isOpen) return;

                const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
                const scrollDistance = Math.abs(scrollTop - openScrollPositionRef.current);

                if (offersScroll && scrollDistance >= offersScroll) {
                    setIsOpen(false);
                }
            };

            window.addEventListener("scroll", handleScroll, { passive: true });

            return () => window.removeEventListener("scroll", handleScroll);
        }, [isOpen]);

        const handleClose = () => {
            sendMetric(`close_vpn_popup`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: null,
                params3: null,
                params4: null,
                params6: null,
                params7: null,
                params8: `${what_id}`,
            });

            // if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
            // window.risMetrika.reachgoal_ch({
            //     event: "close_vpn_popup",
            //     siteId: what_id, //'id витрины',
            //     session_uuid: localStorage.getItem("_r_p_s"),
            //     widget_code: wdCd ? wdCd : "",
            //     ml_traffic_mode: wdm ? wdm : "",
            //     ml_model_code: wd_mc ? wd_mc : "",
            // });
            // }
            setIsOpen(false);
        };

        return (
            <div className="vpn-popover" id="vpn-popover" ref={ref}>
                <div
                    className="vpn-popover__content"
                    onClick={() =>
                        setIsOpen((prev) => {
                            const nextValue = !prev;

                            if (nextValue) {
                                openScrollPositionRef.current = window.scrollY || document.documentElement.scrollTop || 0;
                            }

                            return nextValue;
                        })
                    }
                >
                    <svg className="vpn-popover__icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path
                            d="M6.66667 0C2.99333 0 0 2.99333 0 6.66667C0 10.34 2.99333 13.3333 6.66667 13.3333C10.34 13.3333 13.3333 10.34 13.3333 6.66667C13.3333 2.99333 10.34 0 6.66667 0ZM6.16667 4C6.16667 3.72667 6.39333 3.5 6.66667 3.5C6.94 3.5 7.16667 3.72667 7.16667 4V7.33333C7.16667 7.60667 6.94 7.83333 6.66667 7.83333C6.39333 7.83333 6.16667 7.60667 6.16667 7.33333V4ZM7.28 9.58667C7.24667 9.67333 7.2 9.74 7.14 9.80667C7.07333 9.86667 7 9.91333 6.92 9.94667C6.84 9.98 6.75333 10 6.66667 10C6.58 10 6.49333 9.98 6.41333 9.94667C6.33333 9.91333 6.26 9.86667 6.19333 9.80667C6.13333 9.74 6.08667 9.67333 6.05333 9.58667C6.02 9.50667 6 9.42 6 9.33333C6 9.24667 6.02 9.16 6.05333 9.08C6.08667 9 6.13333 8.92667 6.19333 8.86C6.26 8.8 6.33333 8.75333 6.41333 8.72C6.57333 8.65333 6.76 8.65333 6.92 8.72C7 8.75333 7.07333 8.8 7.14 8.86C7.2 8.92667 7.24667 9 7.28 9.08C7.31333 9.16 7.33333 9.24667 7.33333 9.33333C7.33333 9.42 7.31333 9.50667 7.28 9.58667Z"
                            fill="white"
                        />
                    </svg>
                    <span>VPN</span>
                </div>
                {isOpen && (
                    <div className="vpn-popover__tooltip" onClick={handleClose}>
                        <div className="vpn-popover__tooltip-content">
                            <svg className="vpn-popover__tooltip-close" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path
                                    d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM13.36 12.3C13.65 12.59 13.65 13.07 13.36 13.36C13.21 13.51 13.02 13.58 12.83 13.58C12.64 13.58 12.45 13.51 12.3 13.36L10 11.06L7.7 13.36C7.55 13.51 7.36 13.58 7.17 13.58C6.98 13.58 6.79 13.51 6.64 13.36C6.35 13.07 6.35 12.59 6.64 12.3L8.94 10L6.64 7.7C6.35 7.41 6.35 6.93 6.64 6.64C6.93 6.35 7.41 6.35 7.7 6.64L10 8.94L12.3 6.64C12.59 6.35 13.07 6.35 13.36 6.64C13.65 6.93 13.65 7.41 13.36 7.7L11.06 10L13.36 12.3Z"
                                    fill="#AAADB3"
                                />
                            </svg>
                            У вас включен VPN, поэтому доступен не весь каталог предложений
                        </div>
                    </div>
                )}
            </div>
        );
    }),
);

export default Default;
